<template lang="pug">
div
  #preloader(v-if="loadingResult")
    #loader
  .statement-mobile.bg-white.text-black
    template(v-if="this.category === 'SPORTSBOOK'")
      template(v-if="gameResult.length > 0")
        .statement-single(v-for="data in gameResult")
          .statement-single-content  
            .statement-date {{ $moment(data.bet_time).format("YYYY-MM-DD HH:mm:ss A") }}
            .statement-detail
              .statement-detail-left {{ $t("ui.ref_no") }}: 
              .statement-detail-right {{ data.result_id }}
            .statement-detail
              template(v-if="data.bet_type != 'PARLAY'")
                .statement-detail-left
                  div {{$t('ui.'+ data.sports_category.toLowerCase())}} - {{ getBetTypeName(data.bet_type) }}
                  div {{ getBetDetail(data) }}
                  div(v-if="['HDP', 'HDPH', 'OU', 'OUH', '1X2HDP', '1X2HDPH'].includes(data.bet_type)") {{ data.bet_hand.split(" ")[1] }}
                  div {{data.home_team_name}}
                  div {{data.away_team_name}}
                  div {{data.league_name}}
                .statement-detail-right   
              template(v-else)
                div {{ getBetTypeName(data.bet_type) }}
                  span @ {{ data.odds_display_bet }}
            .statement-detail
              .statement-detail-left {{$t('ui.odds')}}
              .statement-detail-right(:class="{ 'text-danger': parseFloat(data.odds_display) < 0 }") {{ data.odds_display == 0 ? data.odds_display : formatOddsDisplay(data.odds_display, data.bet_type) }}
            .statement-detail
              .statement-detail-left {{$t('ui.stake')}}
              .statement-detail-right {{ $numeral(data.bet_amount).format("0,0.00") }}
            .statement-detail
              .statement-detail-left {{ $t('ui.winlose') }}
              .statement-detail-right {{data.winlose}}
            .statement-detail
              .statement-detail-left {{ $t('ui.status') }}
              .statement-detail-right(:class="getColor(data.winlose)") {{ parseFloat(data.winlose) != 0 ? (parseFloat(data.winlose) < 0 ? $t("ui.lost") : $t("ui.win")) : $t("ui.draw") }}
        .row.pagenumber.py-4
          paginate(
            v-if="!noHistory"
            :click-handler="changePage"
            :pageCount="pageCount"
            :page-range="4"
            :margin-pages="3"
            :prev-text="''"
            :next-text="''"
            :container-class="'p-0 m-0'"
            :page-class="'round'"
            :page-link-class="''"
            :prev-class="'round prev'"
            :next-class="'round next'"
            :prev-link-class="pageCount > 1 && currentPage != 1 ? '' : ''"
            :next-link-class="pageCount > 1 && currentPage != pageCount ? '' : ''")
      template(v-else)
        .text-center.py-2 {{ $t('ui.no_record') }}
    template(v-else)
      template(v-if="this.category === 'REBATE'")
        template(v-if="gameResult.length > 0")
          .statement-single(v-for="data in gameResult")  
            .statement-single-content  
              .statement-date {{ $moment(data.bet_time).format("YYYY-MM-DD HH:mm:ss") }}
              .statement-detail
                .statement-detail-left ID
                .statement-detail-right
                  a.no-deco {{data.result_id}}
              .statement-detail
                .statement-detail-left {{ $t('ui.description') }}
                .statement-detail-right {{data.game_name}}
              .statement-detail
                .statement-detail-left {{ $t('ui.winlose') }}
                .statement-detail-right {{data.winlose}}
          .row.pagenumber.py-4
            paginate(
              v-if="!noHistory"
              :click-handler="changePage"
              :pageCount="pageCount"
              :page-range="4"
              :margin-pages="3"
              :prev-text="''"
              :next-text="''"
              :container-class="'p-0 m-0'"
              :page-class="'round'"
              :page-link-class="''"
              :prev-class="'round prev'"
              :next-class="'round next'"
              :prev-link-class="pageCount > 1 && currentPage != 1 ? '' : ''"
              :next-link-class="pageCount > 1 && currentPage != pageCount ? '' : ''")
        template(v-else)
          .text-center.py-2 {{ $t('ui.no_record') }}
      template(v-else-if="this.category === 'COCKFIGHT'")
        template(v-if="gameResult.length > 0")
          .statement-single(v-for="data in gameResult")  
            .statement-single-content  
              .statement-date {{ $moment(data.bet_time).format("YYYY-MM-DD HH:mm:ss") }}
              .statement-detail
                .statement-detail-left ID
                .statement-detail-right
                  a.no-deco {{data.result_id}}
              .statement-detail
                .statement-detail-left {{ $t('ui.description') }}
                .statement-detail-right
                  div {{data.arena_fight_no}}
                  div {{data.player_hand}}({{data.odd}})
              .statement-detail
                .statement-detail-left {{ $t('ui.winlose') }}
                .statement-detail-right(:class="getColor(data.winlose)") {{data.winlose}}
          .row.pagenumber.py-4
            paginate(
              v-if="!noHistory"
              :click-handler="changePage"
              :pageCount="pageCount"
              :page-range="4"
              :margin-pages="3"
              :prev-text="''"
              :next-text="''"
              :container-class="'p-0 m-0'"
              :page-class="'round'"
              :page-link-class="''"
              :prev-class="'round prev'"
              :next-class="'round next'"
              :prev-link-class="pageCount > 1 && currentPage != 1 ? '' : ''"
              :next-link-class="pageCount > 1 && currentPage != pageCount ? '' : ''")
        template(v-else)
          .text-center.py-2 {{ $t('ui.no_record') }}
      template(v-else)
        template(v-if="gameResult.length > 0")
          .statement-single(v-for="data in gameResult")  
            .statement-single-content  
              .statement-date {{ $moment(data.bet_time).format("YYYY-MM-DD HH:mm:ss") }}
              .statement-detail
                .statement-detail-left ID
                .statement-detail-right
                  a(href="javascript:void(0)" @click="getBetDetails(data.result_id, data.provider_code)") {{data.result_id}}
                  //- a.no-deco(v-else) {{data.result_id}}
              .statement-detail
                .statement-detail-left {{ $t('ui.game_name') }}
                .statement-detail-right {{data.game_name}}
              .statement-detail
                .statement-detail-left {{ $t('ui.winlose') }}
                .statement-detail-right(:class="getColor(data.winlose)") {{data.winlose}}
          .row.pagenumber.py-4
            paginate(
              v-if="!noHistory"
              :click-handler="changePage"
              :pageCount="pageCount"
              :page-range="4"
              :margin-pages="3"
              :prev-text="''"
              :next-text="''"
              :container-class="'p-0 m-0'"
              :page-class="'round'"
              :page-link-class="''"
              :prev-class="'round prev'"
              :next-class="'round next'"
              :prev-link-class="pageCount > 1 && currentPage != 1 ? '' : ''"
              :next-link-class="pageCount > 1 && currentPage != pageCount ? '' : ''")
        template(v-else)
          .text-center.py-2 {{ $t('ui.no_record') }}
  .statement-desktop
    .table-responsive.bg-white.text-black
      table.table-history
        template(v-if="this.category === 'SPORTSBOOK'")
          tr
            th No.
            th {{$t('ui.trans_time')}}
            th {{$t('ui.event')}}
            th {{$t('ui.odds')}}
            th {{$t('ui.stake')}}
            th {{$t('ui.winlose')}}
            th {{$t('ui.status')}}
          template(v-if="gameResult.length > 0")
            tr(v-for="(data, index) in gameResult")
              td.index-col {{index+1}}
              td.custom-col-1
                div {{ $t("ui.ref_no") }}: {{ data.result_id }}
                div {{ $moment(data.bet_time).format("YYYY-MM-DD HH:mm:ss A") }}
              td.custom-col-2
                template(v-if="data.bet_type != 'PARLAY'")
                  div {{$t('ui.'+ data.sports_category.toLowerCase())}} - {{ getBetTypeName(data.bet_type) }}
                  div {{ getBetDetail(data) }}
                  div(v-if="['HDP', 'HDPH', 'OU', 'OUH', '1X2HDP', '1X2HDPH'].includes(data.bet_type)") {{ data.bet_hand.split(" ")[1] }}
                  div {{data.home_team_name}}
                  div {{data.away_team_name}}
                  div {{data.league_name}}
                template(v-else)
                  div {{ getBetTypeName(data.bet_type) }}
                    span @ {{ data.odds_display_bet }}
              td
                div(:class="{ 'text-danger': parseFloat(data.odds_display) < 0 }") {{ data.odds_display == 0 ? data.odds_display : formatOddsDisplay(data.odds_display, data.bet_type) }}
              td {{ $numeral(data.bet_amount).format("0,0.00") }}
              td.custom-col-3
                div 
                  span(:class="{ 'text-danger': parseFloat(data.winlose) < 0 }") {{ $numeral(data.winlose).format("0,0.00") }}
              td {{ parseFloat(data.winlose) != 0 ? (parseFloat(data.winlose) < 0 ? $t("ui.lost") : $t("ui.win")) : $t("ui.draw") }}
            tr
              td.text-center.border-bottom-0(colspan="7")
                .pagenumber.py-4
                  paginate(
                    v-if="!noHistory"
                    :click-handler="changePage"
                    :pageCount="pageCount"
                    :page-range="4"
                    :margin-pages="3"
                    :prev-text="''"
                    :next-text="''"
                    :container-class="'p-0 m-0'"
                    :page-class="'round '"
                    :page-link-class="'text-decoration-none'"
                    :prev-class="'round prev'"
                    :next-class="'round next'"
                    :prev-link-class="pageCount > 1 && currentPage != 1 ? 'text-decoration-none' : 'text-decoration-none'"
                    :next-link-class="pageCount > 1 && currentPage != pageCount ? 'text-decoration-none' : 'text-decoration-none'")
          template(v-else)
            .text-center.py-2 {{ $t('ui.no_record') }}
        template(v-else)
          template(v-if="this.category === 'REBATE'")
            tr
              th ID
              th {{$t('ui.description')}}
              th {{$t('ui.winlose')}}
              th {{$t('ui.date')}}
            template(v-if="gameResult.length > 0")
              tr(v-for="data in gameResult")
                td.no-uppercase
                  a.no-deco(href="javascript:void(0)") {{data.result_id}}
                td {{data.game_name}}
                td {{data.winlose}}
                td {{ $moment(data.bet_time).format("YYYY-MM-DD HH:mm:ss") }}
              tr
                td.text-center.border-bottom-0(colspan="4")
                  .pagenumber.py-4
                    paginate(
                      v-if="!noHistory"
                      :click-handler="changePage"
                      :pageCount="pageCount"
                      :page-range="4"
                      :margin-pages="3"
                      :prev-text="''"
                      :next-text="''"
                      :container-class="'p-0 m-0'"
                      :page-class="'round '"
                      :page-link-class="'text-decoration-none'"
                      :prev-class="'round prev'"
                      :next-class="'round next'"
                      :prev-link-class="pageCount > 1 && currentPage != 1 ? 'text-decoration-none' : 'text-decoration-none'"
                      :next-link-class="pageCount > 1 && currentPage != pageCount ? 'text-decoration-none' : 'text-decoration-none'")
            template(v-else)
              .text-center.py-2 {{ $t('ui.no_record') }}
          template(v-else-if="this.category === 'COCKFIGHT'")
            tr
              th ID
              th {{$t('ui.description')}}
              th {{$t('ui.winlose')}}
              th {{$t('ui.date')}}
            template(v-if="gameResult.length > 0")
              tr(v-for="data in gameResult")
                td.no-uppercase
                  a.no-deco(href="javascript:void(0)") {{data.result_id}}
                td
                  div {{data.arena_fight_no}}
                  div {{data.player_hand}}({{data.odd}})
                td(:class="getColor(data.winlose)") {{data.winlose}}
                td {{ $moment(data.bet_time).format("YYYY-MM-DD HH:mm:ss") }}
              tr
                td.text-center.border-bottom-0(colspan="4")
                  .pagenumber.py-4
                    paginate(
                      v-if="!noHistory"
                      :click-handler="changePage"
                      :pageCount="pageCount"
                      :page-range="4"
                      :margin-pages="3"
                      :prev-text="''"
                      :next-text="''"
                      :container-class="'p-0 m-0'"
                      :page-class="'round '"
                      :page-link-class="'text-decoration-none'"
                      :prev-class="'round prev'"
                      :next-class="'round next'"
                      :prev-link-class="pageCount > 1 && currentPage != 1 ? 'text-decoration-none' : 'text-decoration-none'"
                      :next-link-class="pageCount > 1 && currentPage != pageCount ? 'text-decoration-none' : 'text-decoration-none'")
            template(v-else)
              .text-center.py-2 {{ $t('ui.no_record') }}
          template(v-else)
            tr
              th ID
              th {{$t('ui.game_name')}}
              th {{$t('ui.winlose')}}
              th {{$t('ui.date')}}
            template(v-if="gameResult.length > 0")
              tr(v-for="data in gameResult")
                td.no-uppercase
                  a(href="javascript:void(0)" @click="getBetDetails(data.result_id, data.provider_code)") {{data.result_id}}
                  //- a.no-deco(v-else href="javascript:void(0)") {{data.result_id}}
                td {{data.game_name}}
                td(:class="getColor(data.winlose)") {{data.winlose}}
                td {{ $moment(data.bet_time).format("YYYY-MM-DD HH:mm:ss") }}
              tr
                td.text-center.border-bottom-0(colspan="4")
                  .pagenumber.py-4
                    paginate(
                      v-if="!noHistory"
                      :click-handler="changePage"
                      :pageCount="pageCount"
                      :page-range="4"
                      :margin-pages="3"
                      :prev-text="''"
                      :next-text="''"
                      :container-class="'p-0 m-0'"
                      :page-class="'round '"
                      :page-link-class="'text-decoration-none'"
                      :prev-class="'round prev'"
                      :next-class="'round next'"
                      :prev-link-class="pageCount > 1 && currentPage != 1 ? 'text-decoration-none' : 'text-decoration-none'"
                      :next-link-class="pageCount > 1 && currentPage != pageCount ? 'text-decoration-none' : 'text-decoration-none'")
            template(v-else)
              .text-center.py-2 {{ $t('ui.no_record') }}
</template>
<script>
import config from '@/config'
import Paginate from "vuejs-paginate";
export default {
  components: {
    Paginate
  },
  props:{   
    category: {
      type: String,
    },
  },
  data(){
    return{
      // noHistory: true
      working_date: "",
      currentPage: 1,
      feedback: {
        status: "",
        success: ""
      },
      pageSize: 10,
      path: "",
      loadingResult:false,
    }
  },
  computed:{
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
    gameResult(){
      if(this.category === 'LIVECASINO'){
        return this.$store.getters.livecasinoResult.data;
      }else if(this.category === 'SLOTS'){
        return this.$store.getters.slotResult.data;
      }else if(this.category === 'COCKFIGHT'){
        return this.$store.getters.cockfightResult.data;
      }else if(this.category === 'REBATE'){
        return this.$store.getters.rebateResult.data;
      }else if(this.category === 'SPORTSBOOK'){
        return this.$store.getters.sbResult.data;
      }else{
        return ""
      }
    },
    workingDate() {
      if(this.category === 'LIVECASINO'){
        return this.$store.getters.livecasinoResult.working_date;
      }else if(this.category === 'SLOTS'){
        return this.$store.getters.slotResult.working_date;
      }else if(this.category === 'REBATE'){
        return this.$store.getters.rebateResult.working_date;
      }else if(this.category === 'SPORTSBOOK'){
        return this.$store.getters.sbResult.working_date;
      }else{
        return ""
      }
    },
    noHistory(){
      if(this.gameResult.length > 0){
        return false
      }else{
        return true
      }
    },
    pageCount() {
      if (!this.noHistory) {
        var page = this.gameResult[0].totalrows / 10;
        if (page % 1 != 0) {
          page = page + 1;
        }
        return Math.floor(page);
      } else {
        return 0;
      }
    }
  },
  beforeDestroy(){
    this.reset()
  },
  mounted(){
    window.scroll(0,0)
    // if(this.gameResult.length > 0){
    //   this.noHistory = false
    // }

  },
  methods:{
    getBetTypeName(e) {
      return this.$t("m.BT_" + e);
    },
    formatOddsDisplay(odds, bet_type) {
      if (bet_type == "cs") return calc.fmcs(odds);
      else return this.$helpers.fmt(odds);
    },
    getBetDetail(bet) {
      return this.$helpers.betDisplay(bet, this);
    },
    changePage(e) {
      this.currentPage = e;
      this.$emit("getDifferentPage", {
        workingDate: this.workingDate,
        pageSize: this.pageSize,
        newPage: e,
        category: this.category
      })
    },
    reset(){
      // this.noHistory = true
    },
    getBetDetails(id, provider){
      this.loadingResult = true
      switch(provider){
        case "LIVE22":
          this.path = "user/getLive22Result"
          break;
        case "PG":
        case "FASTSPIN":
        case "YESBINGO":
        case "YL":
        case "JDB":
        case "SEXYBCRT":
        case "VENUS":
        case "JILI":
          this.path = "user/getAwcResult"
          break;
        case "FC":
          this.path = "user/getFcResult"
          break;
        case "EVO":
          this.path = "user/getEvoResult"
          break;
        case "JILI2":
          this.path = "user/getJiliResult"
          break;
        // case "EPIC":
        //   this.path = "user/getEpicResult"
        //   break;
        case "CQ9":
          this.path = "user/getCq9Result"
          break;
        case "HBNR":
          this.path = "user/getHabaneroResult"
          break;
        // case "PP-S":
        case "PP-S123":
          this.path = "user/getPpsResult"
          break;
        case "PP-C":
          this.path = "user/getPpcResult"
          break;
        case "PP-S1":
        case "MG":
        case "SPNX":
        case "SPDG":
        case "BG-S":
        case "HSD":
        case "RG":
        case "EVOP":
        case "PNG":
        case "EVONTT":
        case "EVORT":
        case "EVONLC":
        case "BNG":
        case "AP":
        case "ALG":
        case "SPB":
        case "QM":
        case "PP-C1":
        case "WIFY":
        case "YB":
          this.path = "user/getLaunchoneResult"
          break;
        case "EPIC2":
          this.path = "user/getEpic2Result"
          break;
        case "YGR":
          this.path = "user/getYgrResult"
          break;
        case "WOW":
          this.path = "user/getWowResult"
          break;
        case "PG2":
        case "JILI3":
          this.path = "user/getOpenapiResult"
          break;
        default:
          this.path = ""
      }
      var vm = this
      if(provider === "EPIC"){
        setTimeout(() => {
          vm.loadingResult = false
          window.open(
            config.epicResultUrl + id,
            "info",
            "toolbar=no,scrollbars=no,resizable=no,top=0,left=0,width=480,height=640"
          );
        }) 
      }else if(provider === "TBL"){
        setTimeout(() => {
          vm.loadingResult = false
          window.open(
            config.tblResultUrl + `login_id=${this.accountID}&auth_token=${this.sessionToken}&result_id=${id}&provider=TBL`,
            "info",
            "toolbar=no,scrollbars=no,resizable=no,top=0,left=0,width=480,height=640"
          );
        })
      }else{
        let player_id = this.accountID
        let ticket_id = id
        let lang_code = this.getLanguage
        this.$store
          .dispatch(this.path, { player_id, ticket_id, lang_code })
          .then(response => {
            if (response.success == true) {
              setTimeout(() => {
                vm.loadingResult = false
                window.open(
                  response.data,
                  "info",
                  "toolbar=no,scrollbars=no,resizable=no,top=0,left=0,width=480,height=640"
                );
              }) 
            } else {             
              if((typeof response.status) != 'object'){
                // this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
              this.loadingResult = false
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              // this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
            this.loadingResult = false
          });
      }
    },
    getColor(value) {
      if(value > 0){
        return 'text-success'
      }else{
        return 'text-danger'
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.table-statement .table-statement-row .table-statement-col {
  word-break: break-all;
}
.index-col{
  max-width: 50px;
}
.custom-col-1{
  min-width: 185px;
}
.custom-col-2{
  min-width: 210px;
}
.custom-col-3{
  min-width: 125px;
}
</style>